import React, { useState, useContext } from "react";
import { Menu, Dropdown } from "antd";
import GainIcon from "../gainicon";

import { CardContext } from "./CardTitle";

export default function FilterDropdown() {
  const { Sort } = useContext(CardContext);

  const [Select, setSelect] = useState("Default");
  const menu = (
    <Menu className="rounded-lg px-5 py-3">
      <Menu.Item
        key={false}
        onClick={() => {
          Sort.onSort("Default");
          setSelect("Default");
        }}
      >
        Default
      </Menu.Item>
      {Sort.options.map(
        (item) =>
          item.title && (
            <Menu.Item
              key={item.key}
              onClick={() => {
                Sort.onSort(item.dataIndex);
                setSelect(item.title);
              }}
            >
              {item.title}
            </Menu.Item>
          )
      )}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
      <a className="text-black" onClick={(e) => e.preventDefault()}>
        <span className="pr-6">{Select}</span> <GainIcon name="arrow-down" />
      </a>
    </Dropdown>
  );
}
